import React, { useEffect } from 'react';
import { useFormik, Formik } from 'formik';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { FieldInput, FieldDate } from '../../fields';
import FieldFile from '../../fieldFile';
import { Error } from '../../../design/elements';
const DiscountApprovalForm = ({ discountApprovalRef, defaultValues, isDiscountPrice, dueMonthly, orderData, isDiscountOneTimePrice,OneTimeCharges }) => {
  const validationSchema = Yup.object().shape({
    discountValue: Yup.number()     
    .transform((value, originalValue) => originalValue.trim() === '' ? null : value)     
    .nullable()     
    .moreThan(0, 'Discount value must be greater than 0')     
    .max(dueMonthly, `Discount value must be less than or equal to Due Monthly`),
    oneTimeDiscountValue: Yup.number()     
    .transform((value, originalValue) => originalValue.trim() === '' ? null : value)     
    .nullable()     
    .moreThan(0, 'One time discount value must be greater than 0')     
    .max(OneTimeCharges, `One time discount value must be less than or equal to Due Monthly`),
    discountApprovalId: Yup.string().when(['discountValue', 'oneTimeDiscountValue'], {
        is: (discountValue, oneTimeDiscountValue) => discountValue > 0 || oneTimeDiscountValue > 0,
        then: Yup.string().required('Approver is required when either discount value or one time discount value is greater than 0'),
        otherwise: Yup.string().notRequired()
    }),
    // approverName: Yup.string().when('discountValue', {
    //   is: (discountValue) => discountValue > 0,
    //   then: Yup.string().required('Approver is required'),
    //   otherwise: Yup.string().notRequired()
    // }),
    // approverEmail: Yup.string().when('discountValue', {
    //   is: (discountValue) => discountValue > 0,
    //   then: Yup.string()
    //     .required('Approver Email is required')
    //     .email('Invalid email'),
    //   otherwise: Yup.string().notRequired()
    // }),
    // dateApproved: Yup.string().when('discountValue', {
    //   is: (discountValue) => discountValue > 0,
    //   then: Yup.string().required('Date Approved is required'),
    //   otherwise: Yup.string().notRequired()
    // }),
    // attachmentFile: Yup.string().when('discountValue', {
    //   is: (discountValue) => discountValue > 0,
    //   then: Yup.string().test(
    //     'attachmentFile',
    //     'Attachment file is required',
    //     function(value) {
    //       const { path, createError } = this;
    //       return orderData.attachments.length > 0 || !!value || createError({ path, message: 'Attachment file is required' });
    //     }
    //   ),
    //   otherwise: Yup.string().notRequired()
    // })
  });
  const formik = useFormik({
    initialValues: defaultValues,
    onSubmit: async (values, actions) => {
      try {
        await validationSchema.validate(values, { abortEarly: false });
        if (values.discountValue) {
          values.discountValue = Number(values.discountValue).toFixed(2);
          values.discountValue = values.discountValue.toString();
        }
        if (values.oneTimeDiscountValue) {
            values.oneTimeDiscountValue = Number(values.oneTimeDiscountValue).toFixed(2);
            values.oneTimeDiscountValue = values.oneTimeDiscountValue.toString();
          }
      } catch (validationErrors) {
        const errors = {};
        validationErrors.inner.forEach(error => {
          errors[error.path] = error.message;
        });
        actions.setErrors(errors);
      } finally {
        actions.setSubmitting(false);
      }
    }
    // validationSchema
  });
  useEffect(() => {
    if (discountApprovalRef) {
      // eslint-disable-next-line no-param-reassign
      discountApprovalRef.current = formik;
    }
  }, [discountApprovalRef, formik]);
  return (
    <Formik initialValues={formik.initialValues}>
      <form>
        <div>
          <FieldInput
            data={{
              ref: null,
              name: 'discountValue',
              type: 'Number',
              label: 'Approved Monthly Discount ($)',
              value: formik.values.discountValue,
              required: false,
              onChange: e => {
                isDiscountPrice(e.target.value)
                formik.setFieldValue('discountValue', e.target.value)
              },
              readonly: false,
              tooltip: '',
              note: null,
              disabled: false,
              noteAppearsBelowField: false,
              isShowNoteBackground: false
            }}
          />
            {formik.touched.discountValue && formik.errors.discountValue ? (
              <Error text={formik.errors.discountValue} />
            ) : null}
        </div>
        <div>
          <FieldInput
            data={{
              ref: null,
              name: 'oneTimeDiscountValue',
              type: 'Number',
              label: 'Approved One Time Discount ($)',
              value: formik.values.oneTimeDiscountValue,
              required: false,
              onChange: e => {
                isDiscountOneTimePrice(e.target.value)
                formik.setFieldValue('oneTimeDiscountValue', e.target.value)
              },
              readonly: false,
              tooltip: '',
              note: null,
              disabled: false,
              noteAppearsBelowField: false,
              isShowNoteBackground: false
            }}
          />
            {formik.touched.oneTimeDiscountValue && formik.errors.oneTimeDiscountValue ? (
              <Error text={formik.errors.oneTimeDiscountValue} />
            ) : null}
        </div>

        {(formik.values.discountValue > 0 || formik.values.oneTimeDiscountValue > 0) && (
          <div style={{marginBottom: "170px"}}>
            <FieldInput
              data={{
                ref: null,
                name: 'discountApprovalId',
                type: 'text',
                label: 'Discount Approval ID',
                value: formik.values.discountApprovalId,
                required: true,
                onChange: e => 
                  formik.setFieldValue('discountApprovalId', e.target.value),
                readonly: false,
                tooltip: '',
                note: null,
                disabled: false,
                noteAppearsBelowField: false,
                isShowNoteBackground: false
              }}
            />
            {formik.touched.discountApprovalId && formik.errors.discountApprovalId ? (
              <Error text={formik.errors.discountApprovalId} />
            ) : null}
            {/* <FieldInput
              data={{
                ref: null,
                name: 'approverName',
                type: 'text',
                label: 'Approver Name',
                value: formik.values.approverName,
                required: true,
                onChange: e =>
                  formik.setFieldValue('approverName', e.target.value),
                readonly: false,
                tooltip: '',
                note: null,
                disabled: false,
                noteAppearsBelowField: false,
                isShowNoteBackground: false
              }}
            />
            {formik.touched.approverName && formik.errors.approverName ? (
              <Error text={formik.errors.approverName} />
            ) : null}
            <FieldInput
              data={{
                ref: null,
                name: 'approverEmail',
                type: 'email',
                label: 'Approver Email',
                value: formik.values.approverEmail,
                required: true,
                onChange: e =>
                  formik.setFieldValue('approverEmail', e.target.value),
                readonly: false,
                tooltip: '',
                note: null,
                disabled: false,
                noteAppearsBelowField: false,
                isShowNoteBackground: false
              }}
            />
            {formik.touched.approverEmail && formik.errors.approverEmail ? (
              <Error text={formik.errors.approverEmail} />
            ) : null}
            <FieldDate
              data={{
                ref: null,
                name: 'dateApproved',
                type: 'date',
                label: 'Date Approved',
                value: formik.values.dateApproved,
                required: true,
                onChange: e =>
                  formik.setFieldValue('dateApproved', e.target.value),
                readonly: false,
                tooltip: '',
                note: null,
                disabled: false,
                noteAppearsBelowField: false,
                isShowNoteBackground: false,
              }}
            />
            {formik.touched.dateApproved && formik.errors.dateApproved ? (
              <Error text={formik.errors.dateApproved} />
            ) : null}
            <FieldFile
              data={{
                ref: null,
                name: 'attachmentFile',
                label: 'Attachment',
                required: true,
                onChange: e =>{
                  formik.setFieldValue('attachmentFile',[{discountFile:e.target.files[0]}])},
                note: null,
                value: formik.values.attachmentFile,
                noteAppearsBelowField: false,
                isShowNoteBackground: false
              }}
            />
            {formik.touched.attachmentFile && formik.errors.attachmentFile ? (
              <Error text={formik.errors.attachmentFile} />
            ) : null} */}
          </div>
        )}
      </form>
    </Formik>
  );
};
DiscountApprovalForm.propTypes = {
  discountApprovalRef: PropTypes.shape({
    current: PropTypes.shape({}).isRequired
  }).isRequired,
  defaultValues: PropTypes.shape({
    discountValue: PropTypes.string.isRequired,
    approverEmail: PropTypes.string.isRequired,
    approverName: PropTypes.string.isRequired,
    dateApproved: PropTypes.string.isRequired,
    attachmentFile: PropTypes.string.isRequired
  }).isRequired
};
export default DiscountApprovalForm;